export const TABLE_SKELETON_DEFAULT_ROW_COUNT = 10;
